import api from "./axios";

/**
 * Get balance for a user
 * @param {string} userId - User ID
 * @returns {Promise} Balance object
 */
export const getBalance = async (userId) => {
  try {
    const response = await api.get(`/balance/${userId}`);
    const data = response.data;
    const amount = Number(data?.amount) ?? 0;
    const holdBalance = Number(data?.holdBalance ?? data?.pendingAmount) ?? 0;
    return { amount, holdBalance };
  } catch (error) {
    console.error("Balance API error:", error);
    return { amount: 0, holdBalance: 0 };
  }
};

/**
 * Get balance analytics for a user (campaign breakdown, earnings, etc.)
 * @param {string} userId - User ID
 * @returns {Promise} Analytics object
 */
/** What is on hold, soonest release first, and how long new earnings wait. */
export const getBalanceHolds = async (userId) => {
  const response = await api.get(`/balance/${userId}/holds`);
  return response.data?.data;
};

export const getBalanceAnalytics = async (userId) => {
  try {
    const response = await api.get(`/balance/${userId}/analytics`);
    if (response.data?.success === false) {
      throw new Error(response.data?.message || "Failed to fetch analytics");
    }
    return response.data?.data || response.data;
  } catch (error) {
    console.error("Balance analytics API error:", error);
    throw error;
  }
};

export const getAffiliateAnalytics = async (userId) => {
  try {
    const response = await api.get(`/balance/${userId}/affiliate-analytics`);
    if (response.data?.success === false) {
      throw new Error(response.data?.message || "Failed to fetch affiliate analytics");
    }
    return response.data?.data || response.data;
  } catch (error) {
    console.error("Affiliate analytics API error:", error);
    return {
      referrals: 0,
      linkClicks: 0,
      purchases: 0,
      totalEarned: 0,
    };
  }
};
